var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.5 12h-12A1.5 1.5 0 0 1 0 10.5V1.435A1.5 1.5 0 0 1 1.5 0h12A1.5 1.5 0 0 1 15 1.5v9a1.5 1.5 0 0 1-1.5 1.5m-12-9.099V10.5h12V2.901L7.5 6.9zM2.1 1.5l5.4 3.6 5.4-3.6z"
})));
export default SvgEnvelope;